<aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="liquidacoesEnvio"
  indexColumnVisible="true" limit="10">

  <aslib-grid-column [property]="'id'" [visible]="false" header="id" class="text-right" [width]="1" [sortable]="true"
    [resizable]="true">
  </aslib-grid-column>
 
  <aslib-grid-column [property]="'cnpjCpfCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="175"
  [sortable]="false" [resizable]="true">
  <ng-template #AslibGridCell let-item="item">
    <span>{{item.cnpjCpfCredor | cpf}}</span>
  </ng-template>
</aslib-grid-column>

  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left" [sortable]="true" [width]="400"
    [resizable]="true">
  </aslib-grid-column>

  <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-left" [width]="220"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroProcessoSEI | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>

    <aslib-grid-column [property]="'valor'" header="Valor" class="text-right" [width]="175" [sortable]="true"
    [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.valor | currency:'BRL'}}</span>
    </ng-template>
  </aslib-grid-column>

  <aslib-grid-column [property]="'numeroEmpenho'" header="Número do EMP" class="text-right" [width]="175"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroEmpenho | pedEmpLiq}}</span>
    </ng-template>
  </aslib-grid-column>

  <aslib-grid-column [property]="'enviada'" header="Enviado" class="text-center" [width]="70" [sortable]="false"
    [resizable]="false">
    <ng-template #AslibGridCell let-item="item">
      <div *ngIf="item.enviada"><span class="badge badge badge-success">Sim</span></div>
      <div *ngIf="!item.enviada"><span class="badge badge badge-danger">Não</span></div>
    </ng-template>
  </aslib-grid-column>
  
  <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="80" [sortable]="false" [resizable]="false"
    class="text-center">
    <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
    <ng-template #AslibGridCell let-item="item">
      <button type="button" class="btn btn-sm btn-primary" title="Dados Complementares"
        ascas-data="Informar dados complementares da LIQ"
        (click)="exibirDadosComplementares(dadosComplementares, item)">
        <aslib-icon type="1" icon="fa fa-eye"></aslib-icon>
      </button>
    </ng-template>
  </aslib-grid-column>
</aslib-grid>

<!-- Div para apresentação do model de dados complementares do item selecionado. -->
<ng-template #dadosComplementares>
  <gpa-liq-complemento
    [liquidacaoEnvio]="itemSelecionado">
  </gpa-liq-complemento>
</ng-template>

<div class="form-row">
  <div class="col-md-3">
    <button (click)="enviarLIQ(grid)" [disabled]="!permitirEnvio" style="margin-top: 30px;" type="submit" class="btn btn-primary"
      value="Salvar">
      <aslib-icon type="1" icon="fa fa-paper-plane"></aslib-icon>Enviar
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-empenho/processado/processado-liq-empenho.component.html